
import React from "react";

const Footer = () => {
  const handleNavClick = (href: string) => {
    if (href.startsWith('/')) {
      // 页面路由
      window.REACT_APP_NAVIGATE(href);
    } else {
      // 锚点链接
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-primary text-white">
      <div className="px-6 lg:px-16 py-8 lg:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 lg:gap-8">
          {/* Brand Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/cdcca46642fbb151076a4d1f00d59153.png"
                alt="马帮瑞贡"
                className="w-12 h-9 object-contain drop-shadow-lg hover:drop-shadow-xl transition-all duration-300"
              />
              <div>
                <p className="text-xs text-gray-300">传承马帮精神，奉献地道普洱</p>
              </div>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed mb-4 max-w-md">
              始于1716年，传承三百年马帮精神的普洱茶品牌。秉承"马帮瑞贡，地道普洱"的理念，为您奉献每一杯品质卓越的普洱好茶。
            </p>
            <div className="flex space-x-3">
              <a
                href="#"
                className="w-8 h-8 bg-secondary/20 rounded-full flex items-center justify-center hover:bg-secondary transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-wechat-line text-accent text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 bg-secondary/20 rounded-full flex items-center justify-center hover:bg-secondary transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-weibo-line text-accent text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 bg-secondary/20 rounded-full flex items-center justify-center hover:bg-secondary transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-douyin-line text-accent text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 bg-secondary/20 rounded-full flex items-center justify-center hover:bg-secondary transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-xiaohongshu-line text-accent text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-semibold font-serif mb-3 text-accent">
              快速导航
            </h4>
            <ul className="space-y-1">
              <li>
                <button
                  onClick={() => handleNavClick('#story')}
                  className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  品牌故事
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick('#products')}
                  className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  产品中心
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick('/honors')}
                  className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  荣誉认证
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick('#services')}
                  className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  服务体验
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick('#news')}
                  className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  最新动态
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick('/contact')}
                  className="text-sm text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  联系合作
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-base font-semibold font-serif mb-3 text-accent">
              联系我们
            </h4>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-accent text-sm"></i>
                <span className="text-sm text-gray-300">400-888-1716</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-accent text-sm"></i>
                <span className="text-sm text-gray-300">
                  info@mabangruigong.com
                </span>
              </div>
              <div className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-accent text-sm mt-0.5"></i>
                <span className="text-sm text-gray-300">
                  云南省普洱市思茅区茶马古道文化园
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-600 mt-8 pt-6 flex flex-col lg:flex-row justify-between items-center">
          <p className="text-xs text-gray-400 mb-3 lg:mb-0">
            © 2024 马帮瑞贡茶业有限公司. 保留所有权利. | ICP备案号：滇ICP备2024000001号
          </p>
          <div className="flex items-center space-x-3">
            <a
              href="#"
              className="text-xs text-gray-400 hover:text-accent transition-colors duration-300 cursor-pointer"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-gray-400 hover:text-accent transition-colors duration-300 cursor-pointer"
            >
              服务条款
            </a>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-gray-400 hover:text-accent transition-colors duration-300 cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
